import $ from 'jquery';

export default function () {
    const blockSelector = '.block--related-posts';

    $(blockSelector).each(function () {
        const $block = $(this);
        $block.find('.related-posts__pills .tab').on('click', function(e) {
            e.preventDefault();
            const $tab = $(this);
            const tabId = $tab.data('tab');
            const isActive = $tab.hasClass('active');

            if (isActive) {
                $tab.removeClass('active');
                $block.find('.related-posts__resources-grid > div').addClass('d-none').removeClass('d-block');
                $block.find('.related-posts__resources-grid [data-id="tab__all"]').removeClass('d-none').addClass('d-block');
            } else {
                $block.find('.related-posts__pills .tab').removeClass('active');
                $tab.addClass('active');
                $block.find('.related-posts__resources-grid > div').addClass('d-none');
                $block.find(`.related-posts__resources-grid [data-id="${tabId}"]`).removeClass('d-none').addClass('d-block');
            }
        });
    });

}